import { getDataList } from './data'
import { DataListReq, DataListRes } from './data/types'
import { CreateInvoiceReq, CreateInvoiceRes, Invoice } from './invoice/types'
import { getUnitList } from './unit'
import { getWifiCardList } from './wifiCard'
import invoice from './invoice'
import { UnitGroupRes, UnitListReq } from './unit/types'
import { BillCaptchaCheckReq, BillCaptchaCheckRes, BillCaptchaCreateReq, BillCaptchaCreateRes, CheckNumberRes, GetBillRes } from './bill/types'
import { WIFICARDRes } from './wifiCard/types'
import { checkCaptcha, checkNumber, createCaptcha, getBillInfo } from './bill'
import { CheckConsentRes, CreateConsentRes, SimRecoverRes, TanConfirmReq, TanConfirmResult, TanCreateReq, TanCreateRes } from './sim/types'
import { tanConfirm, tanCreate, get, createConsent, checkConsent } from './sim'
import { DanValidateReq, DanValidateRes } from './dan/types'
import { validate } from './dan'
import { GetEsimDevicesRes } from './info/types'
import { getEsimDevices } from './info'
import { MNP75UnitRes } from './mnp75/types'
import { getUnitList as getMnp75UnitList } from './mnp75'
import { PreorderReq, PreorderRes } from './preorder/types'
import { submitPreorder } from './preorder'
import { getNumberList, lockNumber, updateUserInfo, updateImsi, getInstance, createTan, confirmTan, saveContactInfo, createNumber, getLockedNumbers } from './number'
import { ConfirmTanReq, ConfirmTanRes, CreateTanReq, CreateTanRes, GetInstanceRes, GetLockedNumberRes, GetNumberListReq, GetNumberListRes, LockNumberReq, LockNumberRes, SaveContactInfoReq, UpdateImsiReq, UpdateImsiRes, UpdateUserInfoReq, UpdateUserInfoRes } from './number/types'
import { getCityList, getDistrictList, getQuarterList, getBuildingList } from './mobinet'
import { MobinetDistrictReq, MobinetQuarterReq, MobinetBuildingReq, MobinetCityRes, MobinetDistrictRes, MobinetQuarterRes, MobinetBuildingRes } from './mobinet/types'
import { InstanceNewNumberV2, GetNumberListReqV2, GetNumberListResV2, GetPackageInfo, SaveContactInfoReqV2, SaveNumberReqV2, SavePackageInfoReq, SetSignatureReq, TanConfirmReqV2, TanConfirmResV2, TanCreateResV2, CheckReferralRes, DanChildrenInfoReq, DanChildrenInfoRes, DanCitizenBirthInfoReq, DanCitizenBirthInfoRes, DanPhoneNumbersRes } from './numberv2/types'
import { PackageSavePackageInfoReq, TanConfirmReqV3, InstancePackage, SaveContactInfoReqV3, CreateInstanceReq, InstancePackageShift, GetPackageListReq, PackageListRes, SelectPackageReq, SelectPackageRes, SetSignatureReqV2, TanSendReq, CreditLimitToggleRes, CreateInstanceReqVip, VipCreate, VipValidate } from './packageShift/types'
import { getInstanceV2, doSign, getAgreement, saveContactV2, saveSelfSim, saveEsim, createTanV2, confirmTanV2, getPackageInfo, savePackageInfo, getNumberListV2, saveNumberV2, checkReferral, saveCreditLimitSettings, getChildrenInfo, getCitizenBirthInfo, getPhoneNumbersByRegno } from './numberv2'
import { createTanNumber, createTanEmail, confirmTanV3, savePackageInfoV2, saveContactV3, createInstance, getPackageList, selectPackage, getInfo, sendSign, checkReferralCode, creditLimitPackageShiftToggle, vipCreateInstance, vipShiftValidate } from './packageShift'
import { sendCooperationInfo } from './cooperation'
import { getPackage, getTopupPackage, touristConfirmTanEmail, touristConfirmTanIsdn, touristConfirmTanOnboarding, touristCreateTanEmail, touristCreateTanIsdn, touristGetEmailStatus, touristSaveEsim, touristSaveSelfSim, touristSelectTopupPackage } from './tourist'
import { TopupPackageRes, TouristEmailStatusRes, TouristPackage, TouristSaveSimRes, TouristSelectTopupPackageReq, TouristSelectTopupPackageRes, TouristTanConfirmIsdnReq, TouristTanConfirmOnboardingReq, TouristTanConfirmReq, TouristTanConfirmRes, TouristTanCreateIsdnReq, TouristTanCreateReq, TouristTanCreateRes } from './tourist/types'
import { checkStatus, createTanHandset, confirmTanHandset, getHandsetDti, confirmTanHandsetV2, retryInsurance } from './handsetDti'
import { CheckStatusRequest, CheckStatusResponse, TanCreateRequest, TanCreateResponse, TanConfirmRequest, TanConfirmResponse, DanResponse, TanConfirmRequestV2, TanConfirmResponseV2 } from './handsetDti/types'
import { addPlaylistContent, createPlaylist, deletePlaylist, deletePlaylistContent, downloadContent, getCategories, getContentById, getNewSongs, getPlaylistContents, getPlaylists, getStatus, getTopSongs, giftContent, search, updateFavoriteSchedule, updatePlaylist, updatePlaylistSchedule } from './hitone'
import { HitoneCategoriesRes, HitoneContentRes, HitoneCreatePlaylistReq, HitoneCreatePlaylistRes, HitoneDownloadReq, HitoneDownloadRes, HitoneGiftReq, HitoneGiftRes, HitonePlaylistContentsRes, HitonePlaylistScheduleReq, HitonePlaylistScheduleRes, HitonePlaylistsRes, HitoneSearchReq, HitoneSongsReq, HitoneSongsRes, HitoneStatusRes } from './hitone/types'

type UseMobiApi = () => {
  unit: {
    getList: (req: UnitListReq) => Promise<UnitGroupRes | undefined>
    getMnp75UnitList: (req: UnitListReq) => Promise<MNP75UnitRes | undefined>
  }
  card: {
    getList: (req: UnitListReq) => Promise<WIFICARDRes | undefined>
  }
  data: {
    getList: (req: DataListReq) => Promise<DataListRes | undefined>
  }
  bill: {
    getInfo: (isdn: string, regNo: string, type: string) => Promise<GetBillRes | undefined>
    checkNumber: (isdn: string, type: string) => Promise<CheckNumberRes | undefined>
    createCaptcha: (req: BillCaptchaCreateReq) => Promise<BillCaptchaCreateRes | undefined>
    checkCaptcha: (req: BillCaptchaCheckReq) => Promise<BillCaptchaCheckRes | undefined>
  }
  invoice: {
    get: (_id: string) => Promise<Invoice | undefined>
    create: (req: CreateInvoiceReq) => Promise<CreateInvoiceRes | undefined>
  }
  sim: {
    tanCreate: (req: TanCreateReq) => Promise<TanCreateRes | undefined>
    tanConfirm: (req: TanConfirmReq) => Promise<TanConfirmResult | undefined>
    get: (_id: string) => Promise<SimRecoverRes | undefined>
    createConsent: (sessionId: string) => Promise<CreateConsentRes | undefined>
    checkConsent: (phoneNumber: string) => Promise<CheckConsentRes | undefined>
  }
  dan: {
    validate: (req: DanValidateReq) => Promise<DanValidateRes | undefined>
  }
  info: {
    getEsimDevices: () => Promise<GetEsimDevicesRes | undefined>
  }
  preorder: {
    submitPreorder: (req: PreorderReq) => Promise<PreorderRes | undefined>
  }
  number: {
    getNumberList: (req: GetNumberListReq) => Promise<GetNumberListRes | undefined>
    lockNumber: (req: LockNumberReq) => Promise<LockNumberRes | undefined>
    updateUserInfo: (req: UpdateUserInfoReq) => Promise<UpdateUserInfoRes | undefined>
    updateImsi: (req: UpdateImsiReq) => Promise<UpdateImsiRes | undefined>
    getInstance: (id: string) => Promise<GetInstanceRes | undefined>
    createTan: (req: CreateTanReq) => Promise<CreateTanRes | undefined>
    confirmTan: (req: ConfirmTanReq) => Promise<ConfirmTanRes | undefined>
    saveContactInfo: (req: SaveContactInfoReq) => Promise<UpdateUserInfoRes | undefined>
    createNumber: (id: string) => Promise<UpdateUserInfoRes | undefined>
    getLockedNumbers: (isdn: string) => Promise<GetLockedNumberRes | undefined>
  }
  networkCoverage: {
    getCityList: () => Promise<MobinetCityRes | undefined>
    getDistrictList: (req: MobinetDistrictReq) => Promise<MobinetDistrictRes | undefined>
    getQuarterList: (req: MobinetQuarterReq) => Promise<MobinetQuarterRes | undefined>
    getBuildingList: (req: MobinetBuildingReq) => Promise<MobinetBuildingRes | undefined>
  }
  numberv2: {
    getInstanceV2: (id: string, lang: string) => Promise<InstanceNewNumberV2 | undefined>
    createTanV2: (email: string) => Promise<TanCreateResV2 | undefined>
    confirmTanV2: (req: TanConfirmReqV2) => Promise<TanConfirmResV2 | undefined>
    getPackageInfo: (lang: string, signal: AbortSignal) => Promise<GetPackageInfo | undefined>
    savePackageInfo: (req: SavePackageInfoReq, channel: string) => Promise<InstanceNewNumberV2 | undefined>
    getNumberListV2: (req: GetNumberListReqV2) => Promise<GetNumberListResV2 | undefined>
    saveNumberV2: (req: SaveNumberReqV2) => Promise<InstanceNewNumberV2 | undefined>
    saveEsim: (instanceId: string) => Promise<InstanceNewNumberV2 | undefined>
    saveSelfSim: (instanceId: string, imsi: string) => Promise<InstanceNewNumberV2 | undefined>
    saveContactV2: (req: SaveContactInfoReqV2) => Promise<InstanceNewNumberV2 | undefined>
    getAgreement: (instanceId: string) => Promise<InstanceNewNumberV2 | undefined>
    doSign: (req: SetSignatureReq) => Promise<InstanceNewNumberV2 | undefined>
    checkReferral: (referralCode: string) => Promise<CheckReferralRes | undefined>
    saveCreditLimitSettings: (instanceId: string, usageLimitEnabled: boolean, creditLimitPrice: number) => Promise<{ success: boolean } | undefined>
    getChildrenInfo: (req: DanChildrenInfoReq) => Promise<DanChildrenInfoRes | undefined>
    getCitizenBirthInfo: (req: DanCitizenBirthInfoReq) => Promise<DanCitizenBirthInfoRes | undefined>
    getPhoneNumbersByRegno: (regno: string) => Promise<DanPhoneNumbersRes | undefined>
  }
  packageShift: {
    createTanNumber: (req: TanSendReq) => Promise<TanCreateResV2 | undefined>
    createTanEmail: (req: TanSendReq) => Promise<TanCreateResV2 | undefined>
    confirmTanV3: (req: TanConfirmReqV3) => Promise<TanConfirmResV2 | undefined>
    savePackageInfoV2: (req: PackageSavePackageInfoReq, channel: string) => Promise<InstancePackage | undefined>
    saveContactV3: (req: SaveContactInfoReqV3) => Promise<InstancePackage | undefined>
    createInstance: (req: CreateInstanceReq) => Promise<InstancePackageShift | undefined>
    getPackageList: (req: GetPackageListReq) => Promise<PackageListRes | undefined>
    selectPackage: (req: SelectPackageReq) => Promise<SelectPackageRes | undefined>
    getInfo: (instanceId: string) => Promise<InstancePackage | undefined>
    sendSign: (req: SetSignatureReqV2) => Promise<InstancePackage | undefined>
    checkReferralCode: (referralCode: string, isdn: string, instanceId: string) => Promise<CheckReferralRes | undefined>
    creditLimitPackageShiftToggle: (isdn: string, action: string, instanceId: string, amount: number) => Promise<CreditLimitToggleRes | undefined>
    vipShiftValidate: (instanceId: string) => Promise<VipValidate | undefined>
    vipCreateInstance: (req: CreateInstanceReqVip) => Promise<VipCreate | undefined>
  }
  tourist: {
    getPackage: (promoCode?: string | undefined) => Promise<TouristPackage | undefined>
    getTopupPackage: () => Promise<TopupPackageRes | undefined>
    touristCreateTanEmail: (req: TouristTanCreateReq) => Promise<TouristTanCreateRes | undefined>
    touristConfirmTanEmail: (req: TouristTanConfirmReq) => Promise<TouristTanConfirmRes | undefined>
    touristGetEmailStatus: (isdn: string) => Promise<TouristEmailStatusRes | undefined>
    touristConfirmTanOnboarding: (req: TouristTanConfirmOnboardingReq) => Promise<TouristTanConfirmRes | undefined>
    touristSelectTopupPackage: (req: TouristSelectTopupPackageReq) => Promise<TouristSelectTopupPackageRes | undefined>
    touristCreateTanIsdn: (req: TouristTanCreateIsdnReq) => Promise<TouristTanCreateRes | undefined>
    touristConfirmTanIsdn: (req: TouristTanConfirmIsdnReq) => Promise<TouristTanConfirmRes | undefined>
    touristSaveEsim: () => Promise<TouristSaveSimRes | undefined>
    touristSaveSelfSim: (imsi: string) => Promise<TouristSaveSimRes | undefined>
  }
  handset: {
    checkStatus: (req: CheckStatusRequest) => Promise<CheckStatusResponse | undefined>
    createTanHandset: (req: TanCreateRequest) => Promise<TanCreateResponse | undefined>
    confirmTanHandset: (req: TanConfirmRequest) => Promise<TanConfirmResponse | undefined>
    confirmTanHandsetV2: (req: TanConfirmRequestV2) => Promise<TanConfirmResponseV2 | undefined>
    getHandsetDti: (id: string) => Promise<DanResponse | undefined>
    retry: () => Promise<boolean | undefined>
  }
  hitone: {
    getNewSongs: (req: HitoneSongsReq) => Promise<HitoneSongsRes | undefined>
    getTopSongs: (req: HitoneSongsReq) => Promise<HitoneSongsRes | undefined>
    getCategories: () => Promise<HitoneCategoriesRes | undefined>
    getStatus: (isdn: string) => Promise<HitoneStatusRes | undefined>
    getPlaylists: (isdn: string, page?: number, pageSize?: number) => Promise<HitonePlaylistsRes | undefined>
    createPlaylist: (req: HitoneCreatePlaylistReq, isdn: string) => Promise<HitoneCreatePlaylistRes | undefined>
    getPlaylistContents: (playlistId: number, isdn: string, page?: number, pageSize?: number) => Promise<HitonePlaylistContentsRes | undefined>
    deletePlaylist: (playlistId: number, isdn: string) => Promise<{ success: boolean, message?: string } | undefined>
    deletePlaylistContent: (playlistId: number, contentCode: string, isdn: string) => Promise<{ success: boolean, message?: string } | undefined>
    addPlaylistContent: (playlistId: number, contentCode: string, isdn: string) => Promise<{ success: boolean, message?: string } | undefined>
    updatePlaylist: (playlistId: number, name: string, isdn: string) => Promise<{ success: boolean, message?: string } | undefined>
    updatePlaylistSchedule: (playlistId: number, req: HitonePlaylistScheduleReq, isdn: string) => Promise<HitonePlaylistScheduleRes | undefined>
    updateFavoriteSchedule: (playlistId: number, req: HitonePlaylistScheduleReq, isdn: string) => Promise<HitonePlaylistScheduleRes | undefined>
    getContentById: (contentId: string, isdn?: string) => Promise<HitoneContentRes | undefined>
    search: (req: HitoneSearchReq) => Promise<HitoneSongsRes | undefined>
    downloadContent: (req: HitoneDownloadReq, isdn: string) => Promise<HitoneDownloadRes | undefined>
    giftContent: (contentCode: string, req: HitoneGiftReq, isdn: string) => Promise<HitoneGiftRes | undefined>
  }

}
export const useMobiApi: UseMobiApi = () => {
  return {
    data: { getList: getDataList },
    unit: { getList: getUnitList, getMnp75UnitList },
    card: { getList: getWifiCardList },
    bill: { getInfo: getBillInfo, checkNumber, createCaptcha, checkCaptcha },
    invoice: {
      get: invoice.get,
      create: invoice.create
    },
    sim: { tanCreate, tanConfirm, get, createConsent, checkConsent },
    dan: { validate },
    info: { getEsimDevices },
    preorder: { submitPreorder },
    number: { getNumberList, lockNumber, updateUserInfo, updateImsi, getInstance, createTan, confirmTan, saveContactInfo, createNumber, getLockedNumbers },
    networkCoverage: { getCityList, getDistrictList, getQuarterList, getBuildingList },
    numberv2: { getInstanceV2, createTanV2, confirmTanV2, getPackageInfo, savePackageInfo, getNumberListV2, saveNumberV2, saveEsim, saveSelfSim, saveContactV2, getAgreement, doSign, checkReferral, saveCreditLimitSettings, getChildrenInfo, getCitizenBirthInfo, getPhoneNumbersByRegno },
    packageShift: { createTanNumber, createTanEmail, confirmTanV3, savePackageInfoV2, saveContactV3, createInstance, getPackageList, selectPackage, getInfo, sendSign, checkReferralCode, creditLimitPackageShiftToggle, vipCreateInstance, vipShiftValidate },
    cooperation: { sendInfo: sendCooperationInfo },
    tourist: { getPackage, getTopupPackage, touristConfirmTanEmail, touristCreateTanEmail, touristGetEmailStatus, touristConfirmTanOnboarding, touristSelectTopupPackage, touristCreateTanIsdn, touristConfirmTanIsdn, touristSaveEsim, touristSaveSelfSim },
    handset: {
      checkStatus,
      createTanHandset,
      confirmTanHandset,
      getHandsetDti,
      confirmTanHandsetV2,
      retry: retryInsurance
    },
    hitone: {
      getNewSongs,
      getTopSongs,
      getCategories,
      getStatus,
      search,
      getPlaylists,
      createPlaylist,
      getPlaylistContents,
      deletePlaylist,
      deletePlaylistContent: async (playlistId: number, contentCode: string, isdn: string) =>
        await deletePlaylistContent(playlistId, { contentCode }, isdn),
      addPlaylistContent: async (playlistId: number, contentCode: string, isdn: string) =>
        await addPlaylistContent(playlistId, { contentCode }, isdn),
      updatePlaylist: async (playlistId: number, name: string, isdn: string) =>
        await updatePlaylist(playlistId, { name, type: 0 }, isdn),
      updatePlaylistSchedule: async (playlistId: number, req: HitonePlaylistScheduleReq, isdn: string) =>
        await updatePlaylistSchedule(playlistId, req, isdn),
      updateFavoriteSchedule: async (playlistId: number, req: HitonePlaylistScheduleReq, isdn: string) =>
        await updateFavoriteSchedule(playlistId, req, isdn),
      getContentById,
      downloadContent,
      giftContent
    }
  }
}

export interface MobiErrorRes {
  errorCode?: number
  error?: string
  cause?: {
    messageMn?: string
    messageEn?: string
  }
}
